// removed by extract-text-webpack-plugin
module.exports = {"layout":"_3O8sy-IXMiPL2cCVatJ2T1","top":"_1tt3QgOCqoMdl0rFVTQRdU"};


//////////////////
// WEBPACK FOOTER
// ./src/shell/Shell.css
// module id = 576
// module chunks = 0